import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, firstValueFrom, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import EnterpriseProfile from '../interfaces/ip-enterprise-profile';
import SupplierProfile from '../interfaces/ip-supplier-profile';
import IpUserProfile from '../interfaces/ip-user-profile';
import UserProfileEdition from '../interfaces/ip-user-profile-edition';
import { IpAuthService } from './ip-auth.service';
import { IpRoleService } from './ip-role.service';
import { IpSnackbarService } from './ip-snackbar.service';
import { IpSupplierService } from './ip-supplier.service';
import { MenuOptions } from '../interfaces/ip-enterprise-config-menu';

@Injectable({
  providedIn: 'root'
})
export class IpProfileService {
  api = environment.api;
  private enterpriseSubject: BehaviorSubject<EnterpriseProfile | null> =
    new BehaviorSubject<EnterpriseProfile | null>(null);
  public enterprise$: Observable<EnterpriseProfile | null> =
    this.enterpriseSubject.asObservable();

  private _enterpriseMeuConfig: MenuOptions[] = [];  

  constructor(
    private http: HttpClient,
    private ipAuthService: IpAuthService,
    private ipSupplierService: IpSupplierService,
    private ipRoleService: IpRoleService,
    private ipSnackbarService: IpSnackbarService,
  ) {
   this.ipAuthService.currentSession$.subscribe(session => {
     if (session && !this.enterpriseSubject.value) {
       this.setEnterpriseProfile();
     }
     else if (!session)  {
       this.enterpriseSubject.next(null);
     }
   });
  }

  getUserProfile(): Observable<IpUserProfile> {
    return this.http.get<IpUserProfile>(
      `${this.api}/invopay/users/profile`
    );
  }

  getSupplierProfile(): Observable<SupplierProfile> {
    return this.http.get<SupplierProfile>(
      `${this.api}/invopay/users/profile/supplier`
    );
  }

  private getEnterpriseProfile(): Observable<EnterpriseProfile> {
    return this.http.get<EnterpriseProfile>(
      `${this.api}/invopay/users/profile/enterprise`
    );
  }

  async setEnterpriseProfile(): Promise<void> {
    this.ipRoleService.getAllPermissionsByEnterpriseAndRole().pipe(
        tap((permissions) => this.ipRoleService.setPermissions(permissions))
      ).subscribe();

    let desiredObserver: Observable<EnterpriseProfile>;
    if (this.ipRoleService.getType() !== 'provider') {
      desiredObserver = this.getEnterpriseProfile();
    }
    else {
      // Just a little trick to carry on
      desiredObserver = this.ipSupplierService.getAssignedEnterprises().pipe(
        map(enterprises => {
          return enterprises[0];
        })
      );
    }
    try {
      const enterpriseProfile = await firstValueFrom(desiredObserver)
      
      if (enterpriseProfile.configMenu){
        const menuIds = enterpriseProfile.configMenu.menuIds.split(',').map(id => id.trim()) as MenuOptions[]
        this.enterpriseMeuConfig = menuIds;
      }     
      const userType = this.ipRoleService.getUserType();
      if (this.ipRoleService.getType() === 'business' && userType !== 'ENTERPRISE_MANAGER' && userType !== 'ENTERPRISE_ADMIN'){
        let role = this.ipAuthService.getUserRole()
        if (role === undefined) {
          role = await firstValueFrom(this.ipRoleService.getUserPermission())
          this.ipAuthService.setUserRole(role)
        }
      }
      
      this.enterpriseSubject.next(enterpriseProfile);

    } catch (error) {
     
       // this.ipSnackbarService.showErrorMessage(error.);
      
    }
  }

  updateUserProfile(requestBody: UserProfileEdition): Observable<Object> {
    return this.http.put<Object>(
      `${this.api}/invopay/users/profile`,
      requestBody
    );
  }

  public get enterpriseMeuConfig(): MenuOptions[] {
    return this._enterpriseMeuConfig;
  }

  public set enterpriseMeuConfig(value: MenuOptions[]) {
    this._enterpriseMeuConfig = value;
  }
}
